import { stackValidator } from "utils/formValidators";

import { StackCreationVersion, StackCreationVersionType } from "../../types";

export const getValidateToolVersion =
  (toolVersions?: string[]) => (version: StackCreationVersion) => {
    if (!toolVersions || !version.value.trim()) {
      return "Version is required";
    }

    if (version.type === StackCreationVersionType.Range) {
      return stackValidator.validateVersionRange(version.value, toolVersions, "OpenTofu") || true;
    }

    return true;
  };
